import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "px-16 mt-8 mx-auto max-w-2xl" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/DeShoeysbwDEF.png",
    alt: "deshoey"
  })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_3 = { class: "justify-center w-full flex flex-col" }
const _hoisted_4 = { class: "flex flex-col sm:flex-row justify-center mb-10" }
const _hoisted_5 = { class: "flex flex-col w-full sm:w-96 text-center p-3 sm:p-1 justify-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-base" }, "Total Shoes Staked", -1)
const _hoisted_7 = {
  key: 0,
  class: "text-6xl farm-value"
}
const _hoisted_8 = {
  key: 1,
  class: "text-6xl farm-value"
}
const _hoisted_9 = { class: "flex flex-col w-full sm:w-96 text-center p-3 sm:p-1 justify-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-base" }, "% of Total Shoes Staked", -1)
const _hoisted_11 = {
  key: 0,
  class: "text-6xl farm-value"
}
const _hoisted_12 = {
  key: 1,
  class: "text-6xl farm-value"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center mb-5" }, " No staking account found with this wallet! Make a new one? ", -1)
const _hoisted_17 = { class: "w-full text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_FarmerDisplay = _resolveComponent("FarmerDisplay")!
  const _component_Vault = _resolveComponent("Vault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      active: _ctx.isLoading,
      "is-full-page": _ctx.fullPage,
      loader: _ctx.loader
    }, null, 8, ["active", "is-full-page", "loader"]),
    _hoisted_1,
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                (_ctx.farmAcc)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.farmAcc?.gemsStaked), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(69)))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                (_ctx.farmAcc)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(Math.floor((parseInt(_ctx.farmAcc?.gemsStaked) / 274.0) * 100 * 10) /
              10) + "% ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(69) + "%"))
              ])
            ]),
            _createVNode(_component_ConfigPane)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_FarmerDisplay, {
                  key: _ctx.farmerAcc,
                  farm: _ctx.farm,
                  farmAcc: _ctx.farmAcc,
                  farmer: _ctx.farmer,
                  farmerAcc: _ctx.farmerAcc,
                  class: "mb-10",
                  onRefreshFarmer: _ctx.handleRefreshFarmer
                }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "onRefreshFarmer"]),
                _createVNode(_component_Vault, {
                  key: _ctx.farmerAcc,
                  class: "mb-10",
                  vault: _ctx.farmerAcc.vault.toBase58(),
                  onSelectedWalletNft: _ctx.handleNewSelectedNFT
                }, {
                  default: _withCtx(() => [
                    (_ctx.farmerState === 'staked' && _ctx.selectedNFTs.length > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "bg-rb-mickeyred text-white rounded-lg py-2 px-3 mx-2",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addGems && _ctx.addGems(...args)))
                        }, " Add Gems (resets staking) "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'unstaked')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "bg-rb-mickeyred text-white rounded-lg py-2 px-3 mx-2",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
                        }, " Begin staking "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'staked')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "bg-rb-mickeyred text-white rounded-lg py-2 px-3 mx-2",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " End staking "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'pendingCooldown')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: "bg-rb-mickeyred text-white rounded-lg py-2 px-3 mx-2",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " End cooldown "))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "bg-rb-mickeyred text-white rounded-lg py-2 px-3 mx-2",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
                    }, " Claim " + _toDisplayString(_ctx.availableA / 1000000000) + " $DUST ", 1)
                  ]),
                  _: 1
                }, 8, ["vault", "onSelectedWalletNft"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    class: "bg-rb-mickeyred text-white rounded-lg py-2 px-3 mx-2",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                  }, " Create New Staking Account ")
                ])
              ]))
        ]))
  ], 64))
}